import {booleanComponent, createColumn, defaultColumns, inputTextField} from '../_defaults/columns'

export const columns = [
  // TODO: Needs to be a file upload that saves the file in to the database.
  createColumn({
    label: 'File',
    field: 'fileKey',
    visible: false,
    filterable: false,
    searchable: false,
    component: null
    // component: inputTextField({ req: true, max: 255 })
  }),
  createColumn({
    label: 'Name',
    isTitle: true,
    field: 'name',
    component: inputTextField({ req: true, max: 255 })
  }),
  createColumn({
    label: 'Description',
    field: 'description',
    visible: false,
    filterable: false,
    searchable: false,
    component: null
    // component: inputTextField({ req: false, type: 'textarea', max: 255 })
  }),
  createColumn({
    label: 'Non-Member Price',
    field: 'nonMemberPrice',
    section: 'Pricing',
    type: 'number',
    component: inputTextField({req: true, type: 'number', money: true})
  }),
  createColumn({
    label: 'Member Price',
    field: 'memberPrice',
    section: 'Pricing',
    type: 'number',
    component: inputTextField({req: true, type: 'number', money: true}),
    description: '0 = Free'
  }),
  createColumn({
    label: 'Bundle',
    field: 'isBundle',
    type: 'boolean',
    description: 'Contract is a bundle of all other contracts',
    defaultValue: false,
    component: booleanComponent
  }),
  createColumn({
    label: 'Sort Order',
    field: 'sortOrder',
    type: 'number',
    defaultValue: '0',
    component: inputTextField({ req: true, type: 'number' }),
    description: 'Numeric value that indicates from top to bottom the order of Contracts.  Lower numbers on top.'
  }),
  createColumn({
    label: 'Contract is Active',
    field: 'active',
    type: 'boolean',
    description: 'Contract is listed and available to be purchased',
    defaultValue: true,
    component: booleanComponent
  })
].concat(defaultColumns)
